export default __webpack_public_path__ + "static/media/a6.cbcce7c3.jpg";